/* GRIZZLY — Cart subscribe-upgrade handler (toggle: upgrade ↔ downgrade)
 *
 * Uses event delegation on document — survives ANY cart drawer re-render.
 *
 * Click behavior depends on data-is-active:
 *   - data-is-active="0" → upgrade   (swap to the *-subscription variant, add _GRZ_Sub_* props)
 *   - data-is-active="1" → downgrade (swap back to the plain variant, strip them)
 *
 * ⚠️ This used to POST `selling_plan` to /cart/change.js. Both halves of that
 * were wrong once Payeo's embed went off:
 *
 *   - a native selling_plan makes the cart a subscription CONTRACT, and the
 *     PayPlus gateway cannot pay contracts — checkout offers no payment method
 *     at all; and
 *   - the 15% has to come from the variant, not the plan. The *-subscription
 *     variants are priced AT the subscriber price and sit in the "Bundles +
 *     Gifts" delivery profile (Free, no minimum), which is the only reason a
 *     ₪165.75 box is not charged ₪35 shipping.
 *
 * /cart/change.js cannot change a line's variant, so the toggle is add-then-
 * remove. Add FIRST: if the remove then fails the customer sees a duplicate
 * line they can delete, rather than an empty cart.
 *
 * In both directions, bundle properties (ריחות, _bb-id, _bb-name, _bb-variants)
 * are preserved so the cart-line dropdown stays intact — and _bb-variants is
 * what adoption derives the box size from, so losing it loses the subscription.
 */
(function() {
  if (window.__grzSubUpgradeInit) return;
  window.__grzSubUpgradeInit = true;

  var PLAN_NAME = 'תדירות מנוי: 3 חודשים';
  var CURRENCY  = '₪';

  function refreshSections(data) {
    if (!data || !data.sections) return;
    Object.keys(data.sections).forEach(function(sectionId) {
      var html = data.sections[sectionId];
      if (!html) return;
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      if (sectionId === 'cart-drawer') {
        var oldDrawer = document.querySelector('cart-drawer');
        var newDrawer = doc.querySelector('cart-drawer');
        if (oldDrawer && newDrawer) {
          oldDrawer.innerHTML = newDrawer.innerHTML;
          oldDrawer.classList.remove('is-empty');
          if (typeof oldDrawer.open === 'function') oldDrawer.open();
        }
      } else if (sectionId === 'cart-icon-bubble') {
        var oldBubble = document.querySelector('#cart-icon-bubble');
        if (oldBubble) oldBubble.innerHTML = html;
      } else {
        var oldEl = document.getElementById(sectionId);
        var newEl = doc.getElementById(sectionId);
        if (oldEl && newEl) oldEl.innerHTML = newEl.innerHTML;
      }
    });
  }

  function stripSubscriptionProps(props) {
    var clean = {};
    Object.keys(props || {}).forEach(function(k) {
      if (k.indexOf('_GRZ_Sub_') === 0) return;  // drop _GRZ_Sub_*
      if (k === 'Plan Name' || k === '🔁 מנוי מתחדש') return;  // drop the visible plan line (old and new key)
      if (k === '_grz_upgraded_in_cart') return;      // drop our upgrade marker
      clean[k] = props[k];
    });
    return clean;
  }

  function applySubscriptionProps(existingProps, planId, subIls, oneIls, discountPct) {
    var merged = {};
    Object.keys(existingProps || {}).forEach(function(k) { merged[k] = existingProps[k]; });
    merged['_GRZ_Sub_Plan_ID']            = String(planId || '');
    delete merged['Plan Name'];
    merged['🔁 מנוי מתחדש']            = 'כל 3 חודשים';
    merged['_GRZ_Sub_Plan_Name']          = PLAN_NAME;
    merged['_GRZ_Sub_Price_Per_Delivery'] = subIls;
    merged['_GRZ_Sub_Compare_At_Price']   = oneIls;
    merged['_GRZ_Sub_Discount_Type']      = 'percentage';
    merged['_GRZ_Sub_Discount_Value']     = String(discountPct);
    merged['_GRZ_Sub_Currency']           = CURRENCY;
    merged['_grz_upgraded_in_cart']            = '1';  // mark this upgrade as in-cart-driven
    return merged;
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(r) {
      return r.json().then(function(data) {
        if (!r.ok) {
          var err = new Error(data.description || data.message || ('HTTP ' + r.status));
          err.payload = data;
          throw err;
        }
        return data;
      });
    });
  }

  function getCurrentLine(lineKey) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var item = (cart.items || []).find(function(it) { return it.key === lineKey; });
        if (!item) throw new Error('line not found');
        return item;
      });
  }

  /* Add the replacement line, then drop the original. The final /cart/change.js
     is the call that returns the rendered sections, so the drawer repaints from
     the settled cart rather than the intermediate one. */
  function swapLine(lineKey, variantId, properties) {
    return postJson('/cart/add.js', {
      items: [{ id: Number(variantId), quantity: 1, properties: properties }]
    }).then(function() {
      /* A line's key can change when the add moves an automatic discount (ShoppingIL 2026-11-02: the 187 gifts discount
         gave way to 222 and /cart/change.js answered 400, leaving both boxes). Look the old line up again. */
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r) { return r.json(); });
    }).then(function(cart) {
      var items = cart.items || [], oldVariant = String(lineKey).split(':')[0], bb = (properties || {})['_bb-id'];
      var old = items.find(function(it) { return it.key === lineKey; })
        || items.find(function(it) { return String(it.variant_id) === oldVariant && it.properties && it.properties['_bb-id'] === bb; });
      return postJson('/cart/change.js', {
        id: old ? old.key : lineKey,
        quantity: 0,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      });
    });
  }

  function upgrade(el) {
    var lineKey     = el.dataset.lineKey;
    var subVariant  = el.dataset.subVariantId;
    /* Fallback literal, same as the homepage block's `|| SELLING_PLAN_ID`.
       Payeo owned the selling plan groups and the shop has had none since
       2026-08-13, so the Liquid `sp_id` can resolve empty - and an empty
       _GRZ_Sub_Plan_ID makes the upgraded line read as one-time forever:
       the card keeps offering the upgrade, and the next click runs upgrade()
       again instead of downgrade(), deleting the customer's line. */
    var planId      = el.dataset.planId || '4691067103';
    var subCents    = parseInt(el.dataset.subPriceCents || '0', 10);
    var oneCents    = parseInt(el.dataset.onePriceCents || '0', 10);
    var discountPct = oneCents > 0 ? Math.round((oneCents - subCents) / oneCents * 100) : 15;

    return getCurrentLine(lineKey).then(function(item) {
      var merged = applySubscriptionProps(
        item.properties, planId, (subCents / 100).toFixed(2), (oneCents / 100).toFixed(2), discountPct
      );
      return swapLine(lineKey, subVariant, merged);
    });
  }

  function downgrade(el) {
    var lineKey    = el.dataset.lineKey;
    var oneVariant = el.dataset.oneVariantId;
    return getCurrentLine(lineKey).then(function(item) {
      return swapLine(lineKey, oneVariant, stripSubscriptionProps(item.properties));
    });
  }

  function toggle(el) {
    if (el.classList.contains('is-loading')) return;

    var lineKey  = el.dataset.lineKey;
    var isActive = el.dataset.isActive === '1';
    var target   = isActive ? el.dataset.oneVariantId : el.dataset.subVariantId;

    /* Refuse rather than guess. Without the target variant this used to fall
       back to a selling_plan, which is exactly the failure mode being removed —
       a silent no-op is far better than an unpayable cart. */
    if (!lineKey || !target) {
      console.warn('[grz-sub-upgrade] missing line key or target variant; ignoring click');
      return;
    }

    el.classList.add('is-loading');

    (isActive ? downgrade(el) : upgrade(el))
      .then(function(data) {
        refreshSections(data);
      })
      .catch(function(err) {
        console.error('[grz-sub-upgrade] toggle failed:', err);
        el.classList.remove('is-loading');
      });
  }

  function findCard(target) {
    if (!target || !target.closest) return null;
    return target.closest('.grz-sub-upgrade');
  }

  // Delegated click handler — fires for any .grz-sub-upgrade click, forever.
  document.addEventListener('click', function(e) {
    var el = findCard(e.target);
    if (!el) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(el);
  }, true);

  // Keyboard activation
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = findCard(e.target);
    if (!el) return;
    e.preventDefault();
    toggle(el);
  });
})();
